import React, { useRef, useState } from 'react';
import './Clients.css';

// Import your logo images here
import logo1 from '../Assets/jswclient.png';
import logo2 from '../Assets/bgrclients.png';
import logo3 from '../Assets/maataraniclients.png';

const Clients = () => {
  const scrollRef = useRef(null);
  const [isDragging, setIsDragging] = useState(false);
  const [startX, setStartX] = useState(0);
  const [scrollLeft, setScrollLeft] = useState(0);

  const handleMouseDown = (e) => {
    setIsDragging(true);
    setStartX(e.pageX - scrollRef.current.offsetLeft);
    setScrollLeft(scrollRef.current.scrollLeft);
    scrollRef.current.style.cursor = 'grabbing';
  };

  const handleMouseUp = () => {
    setIsDragging(false);
    scrollRef.current.style.cursor = 'grab';
  };

  const handleMouseMove = (e) => {
    if (!isDragging) return;
    e.preventDefault();
    const x = e.pageX - scrollRef.current.offsetLeft;
    const walk = (x - startX) * 2;
    scrollRef.current.scrollLeft = scrollLeft - walk;
  };

  const handleMouseLeave = () => {
    if (isDragging) {
      setIsDragging(false);
      scrollRef.current.style.cursor = 'grab';
    }
  };

  // Array of client logos - add your imported images here
  const clientLogos = [
    logo1,
    logo2,
    logo3,
  ];

  return (
    <section className="clients-section">
      <div className="clients-container">
        <h2 className="clients-title">More than 100+ companies trust us worldwide</h2>
        
        <div 
          className="clients-scroll-wrapper"
          ref={scrollRef}
          onMouseDown={handleMouseDown}
          onMouseUp={handleMouseUp}
          onMouseMove={handleMouseMove}
          onMouseLeave={handleMouseLeave}
        >
          <div className="clients-list">
            {clientLogos.map((logo, index) => (
              <div key={index} className="clients-item">
                <img 
                  src={logo} 
                  alt={`Client ${index + 1}`} 
                  className="clients-logo"
                  draggable="false"
                />
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Clients;